import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import translationActions from '../../store/actions/language';
import useCloseOnBlur from '../../customHooks/useCloseOnBlur';
import IconCheckmark from './Icons/IconCheckmark';
import helpers from '../../helpers/helpers';
import categoriesActions from '../../store/actions/categoriesActions';
import {useRouter} from 'next/router';

const SwitchLanguage = () => {
  const { getTranslationText, getFlag } = helpers;
  const router = useRouter();

  const [isLanguageDropdown, toggleLanguageDropdown] = useState(false);

  const closeLanguageDropdown = (isDropdown) => toggleLanguageDropdown(isDropdown);

  const dispatch = useDispatch();
  const { language, languageList } = useSelector((state) => state.language);

  const wrapperRef = useRef(null);
  useCloseOnBlur(wrapperRef, closeLanguageDropdown);

  const switchLanguageHandler = (code) => {
    dispatch(translationActions.setLanguage(code));
    const headers = {};
    headers['accept-language'] = code;
    dispatch(categoriesActions.getCategories(headers));
    router.push(router.pathname, router.asPath, { locale: code.split('-')[0] });
  };

  return (
    <div
      className={
        isLanguageDropdown ? 'switch-language active' : 'switch-language'
      }
      onClick={() => toggleLanguageDropdown(!isLanguageDropdown)}
      role="button"
      tabIndex={0}
    >
      <div className="switch-language__toggle">
        {getFlag(language)}
      </div>
      {isLanguageDropdown && (
        <div className="switch-language__dropdown" ref={wrapperRef}>
          <div className="switch-language__dropdown__title">{getTranslationText('header.language')}</div>
          {
            languageList.map((el) => (
              <div className="switch-language__dropdown__item" onClick={() => switchLanguageHandler(el.code)}>
                {getFlag(el.code)}
                {el.title}
                {language === el.code && (
                  <div className="selected">
                    <IconCheckmark color="#4579F5" />
                  </div>
                )}
              </div>
            ))
          }
        </div>
      )}
    </div>
  );
};

export default SwitchLanguage;
